import { createDeformedCube, CUBE_PARAMS } from "./CubeBase";

// 誤り5: 上面を上から覗いたように開いて描く誤り（上面の見かけの奥行き過大）
// 「立方体の上面は正方形である」というカテゴリスキーマが、紙面上で上面の面積を
// 確保させる誤り（model1「皿を丸く描く」の立方体版）。
//
// 底面固定ブレンドで構成：底面(y=-half)は不動、上面(y=+half)の頂点だけを
// 「x軸まわりに角度Δだけ回転」させる。この回転は、
// 「カメラを仰角+Δだけ高い視点Eへ動かす」ことの逆変換（世界を-Δ回転）に一致するため、
// 誤りモデルを既定視点Dから見た上面の見え＝モチーフを視点Eから見た上面の見え、が厳密に成立する
// （＝「あなたの描いた上面は、モチーフを上から覗いた姿です」と順方向で説明できる）。
// 回転軸はカメラの注視点(ワールド原点)を通るx軸でなければ上の厳密一致が崩れる。
// ModelLoader が position.set(150,60,0) で底面をワールドy=0に載せるため、
// ローカル座標では「底面(y=-half)を通るx軸」がそれに当たる（x方向のずれは軸方向なので無関係）。
// 中間の高さの頂点は存在しないため w(y) は実質 0/1 の二値だが、将来ジオメトリを
// 分割しても自然に馴染むよう一般式のまま実装する。
// shearValue: 0=正解(立方体), 0.5=誤り, 0.2=中間
const DELTA_MAX = (20 * Math.PI) / 180; // 既定仰角(約23°)に対し+20°

export function createCubeModel5(shearValue, faceColors, errorEdges) {
  shearValue = shearValue !== undefined ? shearValue : 0.5;
  const half = CUBE_PARAMS.size / 2;
  const delta = (shearValue / 0.5) * DELTA_MAX;
  const cos = Math.cos(delta);
  const sin = Math.sin(delta);

  return createDeformedCube((x, y, z) => {
    const w = (y + half) / (2 * half); // 底面0 → 上面1
    // 底面(y=-half)を通るx軸まわりの回転
    const rotY = -half + (y + half) * cos + z * sin;
    const rotZ = -(y + half) * sin + z * cos;
    return [
      x,
      (1 - w) * y + w * rotY,
      (1 - w) * z + w * rotZ,
    ];
  }, faceColors, errorEdges);
}
